<i18n>
{
  "fr": {
    "add-project-title": "Ajouter un projet",
    "add-project-form-title-label": "Identifiant de projet",
    "add-project-form-title-placeholder": "Nom, numéro, client ou autre",
    "add-project-form-province-label" : "Province",
    "add-project-form-province-placeholder" : "Assigner une province",
    "add-project-form-project-template-label": "Gabarit de projet",
    "add-project-form-eem-may-affect-native-communites-label": "Les activités de votre projet sont-elles susceptibles d’affecter des communautés autochtones?",
    "add-project-form-eem-may-affect-stakeholders-label": "Les activités de votre projet sont-elles susceptibles d’affecter d'autres parties prenantes?",
    "add-project-form-eem-is-located-in-local-authority-label": "Votre projet est-il situé sur le territoire d’une autorité ou municipalité locale?",
    "add-project-form-fs-represents-native-communities-label": "Êtes-vous mandaté pour représenter l’entreprise d’exploration minière auprès des communautés autochtones?",
    "add-project-form-fs-represents-stakeholders-label": "Êtes-vous mandaté pour représenter l’entreprise d’exploration minière auprès des autres parties prenantes?",
    "add-project-form-fs-represents-local-authorities-label": "Êtes-vous mandaté pour représenter l’entreprise d’exploration minière auprès des autorités locales?",
    "add-project-form-fs-represents-government-authorities-label": "Êtes-vous mandaté pour représenter l’entreprise d’exploration minière auprès des autorités régionales et gouvernementales?",
    "add-project-form-fs-checks-territorial-constraints-label": "Êtes-vous mandaté pour effectuer les vérifications liées aux contraintes territoriales?",
    "add-project-form-submit-btn": "Ajouter le projet",
    "error-add-project-form-title-empty": "L'identifiant du projet est obligatoire",
    "error-add-project-form-province-empty": "La province du projet est obligatoire",
    "error-add-project-form-radio-not-selected": "Vous devez répondre à la question",
    "projects-list-title": "Conformité par projet",
    "radio-yes": "Oui",
    "radio-no": "Non"
  },
  "en": {
    "add-project-title": "Add project",
    "add-project-form-title-label": "Project name",
    "add-project-form-title-placeholder": "Name, number, client or other",
    "add-project-form-province-label" : "Province",
    "add-project-form-province-placeholder" : "Set the project province",
    "add-project-form-project-template-label": "Project template",
    "add-project-form-eem-may-affect-native-communites-label": "Are your project activities likely to affect Indigenous communities?",
    "add-project-form-eem-may-affect-stakeholders-label": "Are your project activities likely to affect other stakeholders?",
    "add-project-form-eem-is-located-in-local-authority-label": "Is your project located on the territory of a local authority or municipality?",
    "add-project-form-fs-represents-native-communities-label": "Are you mandated to represent the mineral exploration company with Indigenous communities?",
    "add-project-form-fs-represents-stakeholders-label": "Are you mandated to represent the mineral exploration company with other stakeholders?",
    "add-project-form-fs-represents-local-authorities-label": "Are you mandated to represent the mineral exploration company with local authorities?",
    "add-project-form-fs-represents-government-authorities-label": "Are you mandated to represent the mineral exploration company with regional or government authorities?",
    "add-project-form-fs-checks-territorial-constraints-label": "Are you mandated to carry out verifications related to territorial constraints?",
    "add-project-form-submit-btn": "Add the project",
    "error-add-project-form-title-empty": "Project name is required",
    "error-add-project-form-province-empty": "Project province is required",
    "error-add-project-form-radio-not-selected": "You must answer the question",
    "projects-list-title": "Project compliance",
    "radio-yes": "Yes",
    "radio-no": "No"
  }
}
</i18n>

<template>
  <div class="card">
    <ui-heading :title="$t('add-project-title')" />

    <ui-box>
      <s-loader :active="!businessCategory && $apollo.queries.infos.loading" />
      <s-form ref="form" @submit="createProject" v-if="businessCategory && !$apollo.queries.infos.loading">
        <!-- Project id -->
        <s-field
          class="mb-24px has-max-width-480"
          :label="$t('add-project-form-title-label')"
          label-for="title"
          :value="projectModel.name"
          :rules="rules.title"
        >
          <b-input v-model="projectModel.name" :placeholder="$t('add-project-form-title-placeholder')" id="title"></b-input>
        </s-field>

        <!-- Province code -->
        <s-field
          class="mb-24px has-max-width-480"
          :label="$t('add-project-form-province-label')"
          label-for="provinceCode"
          :value="projectModel.provinceCode"
          :rules="rules.provinceCode"
        >
          <b-select expanded :placeholder="$t('add-project-form-province-placeholder')" v-model="projectModel.provinceCode">
            <option v-for="i in provinceCodes" :key="i.value" :value="i.value">{{ i.text }}</option>
          </b-select>
        </s-field>

        <!-- Project templateid -->
        <s-field
          v-if="projectTemplates && projectTemplates.length > 1"
          class="mb-24px has-max-width-480"
          :label="$t('add-project-form-project-template-label')"
          label-for="title"
          :value="projectModel.name"
          :rules="rules.title"
        >
          <b-select v-model="projectModel.projectTemplateId">
            <option v-for="option in projectTemplates" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </s-field>

        <!-- Questions EEM -->
        <template v-if="isEEM">
          <!-- mayAffectNativeCommunites -->
          <s-field
            class="mb-24px has-max-width-480"
            :label="$t('add-project-form-eem-may-affect-native-communites-label')"
            label-for="mayAffectNativeCommunites"
            :value="projectModel.mayAffectNativeCommunites"
            :rules="rules.radio"
            validate-on-input
          >
            <div>
              <b-radio v-model="projectModel.mayAffectNativeCommunites" name="mayAffectNativeCommunites" :native-value="true">
                {{ $t('radio-yes') }}
              </b-radio>
              <b-radio v-model="projectModel.mayAffectNativeCommunites" name="mayAffectNativeCommunites" :native-value="false">
                {{ $t('radio-no') }}
              </b-radio>
            </div>
          </s-field>

          <!-- mayAffectStakeholders -->
          <s-field
            class="mb-24px has-max-width-480"
            :label="$t('add-project-form-eem-may-affect-stakeholders-label')"
            label-for="mayAffectStakeholders"
            :value="projectModel.mayAffectStakeholders"
            :rules="rules.radio"
            validate-on-input
          >
            <div>
              <b-radio v-model="projectModel.mayAffectStakeholders" name="mayAffectStakeholders" :native-value="true">
                {{ $t('radio-yes') }}
              </b-radio>
              <b-radio v-model="projectModel.mayAffectStakeholders" name="mayAffectStakeholders" :native-value="false">
                {{ $t('radio-no') }}
              </b-radio>
            </div>
          </s-field>

          <!-- isLocatedInLocalAuthority -->
          <s-field
            class="mb-24px has-max-width-480"
            :label="$t('add-project-form-eem-is-located-in-local-authority-label')"
            label-for="isLocatedInLocalAuthority"
            :value="projectModel.isLocatedInLocalAuthority"
            :rules="rules.radio"
            validate-on-input
          >
            <div>
              <b-radio v-model="projectModel.isLocatedInLocalAuthority" name="isLocatedInLocalAuthority" :native-value="true">
                {{ $t('radio-yes') }}
              </b-radio>
              <b-radio v-model="projectModel.isLocatedInLocalAuthority" name="isLocatedInLocalAuthority" :native-value="false">
                {{ $t('radio-no') }}
              </b-radio>
            </div>
          </s-field>
        </template>

        <!-- Questions FS -->
        <template v-if="isFS">
          <!-- representsNativeCommunities -->
          <s-field
            class="mb-24px has-max-width-480"
            :label="$t('add-project-form-fs-represents-native-communities-label')"
            label-for="representsNativeCommunities"
            :value="projectModel.representsNativeCommunities"
            :rules="rules.radio"
            validate-on-input
          >
            <div>
              <b-radio v-model="projectModel.representsNativeCommunities" name="representsNativeCommunities" :native-value="true">
                {{ $t('radio-yes') }}
              </b-radio>
              <b-radio
                v-model="projectModel.representsNativeCommunities"
                name="representsNativeCommunities"
                :native-value="false"
              >
                {{ $t('radio-no') }}
              </b-radio>
            </div>
          </s-field>

          <!-- representsStakeholders -->
          <s-field
            class="mb-24px has-max-width-480"
            :label="$t('add-project-form-fs-represents-stakeholders-label')"
            label-for="representsStakeholders"
            :value="projectModel.representsStakeholders"
            :rules="rules.radio"
            validate-on-input
          >
            <div>
              <b-radio v-model="projectModel.representsStakeholders" name="representsStakeholders" :native-value="true">
                {{ $t('radio-yes') }}
              </b-radio>
              <b-radio v-model="projectModel.representsStakeholders" name="representsStakeholders" :native-value="false">
                {{ $t('radio-no') }}
              </b-radio>
            </div>
          </s-field>

          <!-- representsLocalAuthorities -->
          <s-field
            class="mb-24px has-max-width-480"
            :label="$t('add-project-form-fs-represents-local-authorities-label')"
            label-for="representsLocalAuthorities"
            :value="projectModel.representsLocalAuthorities"
            :rules="rules.radio"
            validate-on-input
          >
            <div>
              <b-radio v-model="projectModel.representsLocalAuthorities" name="representsLocalAuthorities" :native-value="true">
                {{ $t('radio-yes') }}
              </b-radio>
              <b-radio v-model="projectModel.representsLocalAuthorities" name="representsLocalAuthorities" :native-value="false">
                {{ $t('radio-no') }}
              </b-radio>
            </div>
          </s-field>

          <!-- representsGovernmentAuthorities -->
          <s-field
            class="mb-24px has-max-width-480"
            :label="$t('add-project-form-fs-represents-government-authorities-label')"
            label-for="representsGovernmentAuthorities"
            :value="projectModel.representsGovernmentAuthorities"
            :rules="rules.radio"
            validate-on-input
          >
            <div>
              <b-radio
                v-model="projectModel.representsGovernmentAuthorities"
                name="representsGovernmentAuthorities"
                :native-value="true"
              >
                {{ $t('radio-yes') }}
              </b-radio>
              <b-radio
                v-model="projectModel.representsGovernmentAuthorities"
                name="representsGovernmentAuthorities"
                :native-value="false"
              >
                {{ $t('radio-no') }}
              </b-radio>
            </div>
          </s-field>

          <!-- checksTerritorialConstraints -->
          <s-field
            class="mb-24px has-max-width-480"
            :label="$t('add-project-form-fs-checks-territorial-constraints-label')"
            label-for="checksTerritorialConstraints"
            :value="projectModel.checksTerritorialConstraints"
            :rules="rules.radio"
            validate-on-input
          >
            <div>
              <b-radio
                v-model="projectModel.checksTerritorialConstraints"
                name="checksTerritorialConstraints"
                :native-value="true"
              >
                {{ $t('radio-yes') }}
              </b-radio>
              <b-radio
                v-model="projectModel.checksTerritorialConstraints"
                name="checksTerritorialConstraints"
                :native-value="false"
              >
                {{ $t('radio-no') }}
              </b-radio>
            </div>
          </s-field>
        </template>

        <p
          :class="{
            'mt-24px': $media.mobile,
            'mt-32px': $media.tablet,
            'mt-48px': $media.widescreen
          }"
        >
          <b-button type="is-link" native-type="submit" :loading="loading">{{ $t('add-project-form-submit-btn') }}</b-button>
        </p>
      </s-form>
    </ui-box>
  </div>
</template>

<script>
import BusinessService from '@/services/business'
import ProvinceService from '@/services/province'
import Breadcrumbs from '@/mixins/breadcrumbs'
import FormHelper from '@/helpers/form'
import EnumHelper from '@/helpers/enums'
import { URL_PROJECT_LIST } from '@/consts/urls'
import {
  BUSINESS_CATEGORY_EEM,
  BUSINESS_CATEGORY_PROVIDER,
  PROJECT_STATUS_ACTIVE,
  PROJECT_STATUS_INACTIVE,
  PROJECT_STATUS_FINISH
} from '@/consts/enums'

import SForm from '@/components/form/form'
import SField from '@/components/form/field'
import UiBox from '@/components/ui/box'
import UiHeading from '@/components/ui/heading'

const PROJECT_STATUSES = [PROJECT_STATUS_ACTIVE, PROJECT_STATUS_INACTIVE, PROJECT_STATUS_FINISH]

export default {
  components: { SForm, SField, UiBox, UiHeading },
  mixins: [Breadcrumbs],
  data() {
    return {
      loading: true,
      businessId: null,
      businessCategory: null,
      projectModel: {
        name: '',
        projectTemplateId: null,
        mayAffectNativeCommunites: null,
        mayAffectStakeholders: null,
        isLocatedInLocalAuthority: null,
        representsNativeCommunities: null,
        representsStakeholders: null,
        representsLocalAuthorities: null,
        representsGovernmentAuthorities: null,
        checksTerritorialConstraints: null
      },
      rules: {
        title: [(val) => !FormHelper.stringEmpty(val) || this.$t('error-add-project-form-title-empty')],
        provinceCode: [(val) => !FormHelper.stringEmpty(val) || this.$t('error-add-project-form-province-empty')],
        radio: [(val) => FormHelper.isBoolean(val) || this.$t('error-add-project-form-radio-not-selected')]
      }
    }
  },
  mounted() {
    this.businessId = BusinessService.getCurrentBusiness().id
    this.loading = false
  },
  computed: {
    breadcrumbs() {
      return [
        {
          label: this.$t('projects-list-title'),
          url: { name: URL_PROJECT_LIST }
        },
        {
          label: this.$t('add-project-title')
        }
      ]
    },
    isEEM() {
      // BAT-3103 - Voir note au backend dans IndicatorApplicabilityResolver
      return false
      // eslint-disable-next-line no-unreachable
      return this.businessCategory === BUSINESS_CATEGORY_EEM
    },
    isFS() {
      // BAT-3103 - Voir note au backend dans IndicatorApplicabilityResolver
      return false
      // eslint-disable-next-line no-unreachable
      return this.businessCategory === BUSINESS_CATEGORY_PROVIDER
    },
    projectStatus() {
      return PROJECT_STATUSES.map((x) => {
        return {
          id: x,
          text: EnumHelper.formatProjectStatus(x)
        }
      })
    },
    provinceCodes() {
      return ProvinceService.getAllProvinces()
    }
  },
  methods: {
    async createProject() {
      if (this.$refs.form.validate()) {
        this.loading = true

        try {
          await this.$apollo.mutate({
            mutation: this.$options.mutation.CreateProject,
            variables: {
              input: {
                businessId: this.businessId,
                projectTemplateId: this.projectTemplateId,
                ...this.projectModel
              }
            }
          })

          this.$router.push({ name: URL_PROJECT_LIST })
        } finally {
          this.loading = false
        }
      }
    }
  },
  apollo: {
    infos: {
      query() {
        return this.$options.query.CreateProject_Infos
      },
      variables() {
        return {
          businessId: this.businessId
        }
      },
      skip() {
        return !this.businessId
      },
      update(data) {
        if (!data) return
        this.businessCategory = data.business.category
        this.projectTemplates = data.projectTemplates
        this.projectModel.projectTemplateId = data.projectTemplates.length > 0 ? data.projectTemplates[0].id : null
      }
    }
  }
}
</script>

<graphql>
query CreateProject_Infos($businessId: ID!) {
  business(id: $businessId) {
    id
    category
  }

  projectTemplates(businessId: $businessId) {
    id
    name
  }
}

mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    project {
      id
    }
  }
}
</graphql>
